<template lang='pug' src='./nav-tablet.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      active: false,
      scroll: 0,
      scrollingUp: true
    }
  },
  props: ['props'],
  computed: {
    links () {
      return this.$router.options.routes
    },
    classList () {
      return {
        'top': this.$route.name !== 'contact' && !this.$store.state.nav
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  components: {
    Icon
  },
  methods: {
    handleScroll () {
      let currentScroll = window.scrollY

      if (currentScroll < this.scroll) {
        this.scrollingUp = true
      } else {
        this.scrollingUp = false
      }
      this.scroll = currentScroll
    }
  }
}

</script>



// WEBPACK FOOTER //
// nav-tablet.vue?4ea225fe